import axios from 'axios'
import { DirectoEventResponse } from '../../../../../api/models/directo-event-response'
import { TransitOperationDirectoRequest } from '../../../../../api/models/transit-operation-directo-request'

const baseUrl = `${process.env.REACT_APP_API_URL}/v2/directo-event`

export async function fetchDirectoEventV2(params: { transitOperationId: number }, opts?: { signal?: AbortSignal }) {
  const { data } = await axios.get<DirectoEventResponse>(`${baseUrl}/${params.transitOperationId}`, {
    signal: opts?.signal,
  })

  return data
}

export async function createDirectoEventV2(request: TransitOperationDirectoRequest) {
  const { data } = await axios.post<DirectoEventResponse>(baseUrl, request)

  return data
}

export async function updateDirectoEventV2(id: number, request: TransitOperationDirectoRequest) {
  const { data } = await axios.put<DirectoEventResponse>(`${baseUrl}/${id}`, request)

  return data
}
